import React from 'react';
import { Box } from '@material-ui/core';
import { StarBorder } from '@material-ui/icons';

export const RatingFieldPreview = React.memo(() => (
  <Box display='flex' alignItems='center'>
    <StarBorder color='disabled' />
    <StarBorder color='disabled' />
    <StarBorder color='disabled' />
    <StarBorder color='disabled' />
    <StarBorder color='disabled' />
  </Box>
));
